import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Driver-index-1992f2b737e209f04-1'),
    routerUrl: '/Driver',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Driver')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Driver-index-1992f2b737e209f04-2'),
        routerUrl: '/DriverForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./DriverForm')),
      },
      //$MORE$
    ],
  },
];
